/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Filesize_Gigabytes1Inputs */

const en_filesize_gigabytes1 = /** @type {(inputs: Filesize_Gigabytes1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.size} GB`)
};

/**
* | output |
* | --- |
* | "{size} GB" |
*
* @param {Filesize_Gigabytes1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const filesize_gigabytes1 = /** @type {((inputs: Filesize_Gigabytes1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesize_Gigabytes1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_filesize_gigabytes1(inputs)
});
export { filesize_gigabytes1 as "fileSize_gigabytes" }